<div class="title">
  <p-heading [size]="'x-large'" [tag]="'h3'">Vendors</p-heading>

  <p-button
    [hideLabel]="(mediaMaxXs$ | async) ?? false"
    [iconSource]="'assets/icons/add.svg'"
    [variant]="'secondary'"
    (click)="showCreateModal = true"
  >
    Add New Vendor
  </p-button>
</div>

<p-divider aria-hidden="true" />

<section class="list">
  <p-heading *ngrxLet="data$ | async as vendors" [size]="'small'" [tag]="'h4'">
    {{ vendors?.length }} Vendors
  </p-heading>

  <ng-container *ngrxLet="data$ as data; error as dataError; suspenseTpl: spinner">
    <div *ngIf="dataError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadData()"
      >
        Reload Vendors
      </p-button-pure>
    </div>

    <ng-container *ngIf="!dataError && data">
      <div class="overlay-spinner-host">
        <ng-container *ngIf="loading$ | async" [ngTemplateOutlet]="overlaySpinner" />

        <p-table caption="Vendor list table">
          <p-table-head>
            <p-table-head-row>
              <p-table-head-cell style="width: 1%">Edit</p-table-head-cell>
              <p-table-head-cell style="width: 49%">Name</p-table-head-cell>
              <p-table-head-cell style="width: 49%">Legal Name</p-table-head-cell>
              <p-table-head-cell style="width: 1%">Delete</p-table-head-cell>
            </p-table-head-row>
          </p-table-head>

          <p-table-body>
            <p-table-row *ngFor="let vendor of data; trackBy: trackVendor">
              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/edit.svg'"
                  [hideLabel]="true"
                  (click)="openEditModal(vendor)"
                >
                  Edit {{ vendor.name }}
                </p-button-pure>
              </p-table-cell>

              <p-table-cell>
                {{ vendor.name }}
              </p-table-cell>

              <p-table-cell>
                {{ vendor.legalName }}
              </p-table-cell>

              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/delete.svg'"
                  [hideLabel]="true"
                  (click)="openDeleteModal(vendor)"
                >
                  Delete {{ vendor.name }}
                </p-button-pure>
              </p-table-cell>
            </p-table-row>
          </p-table-body>
        </p-table>
      </div>
    </ng-container>
  </ng-container>
</section>

<opa-vendor-create
  [open]="showCreateModal"
  (dismiss)="showCreateModal = false; $event && reloadData()"
/>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>

<ng-template #overlaySpinner>
  <div class="overlay-spinner"><p-spinner /></div>
</ng-template>

<opa-vendor-delete
  [open]="showDeleteModal"
  [vendor]="(vendor$ | async) ?? undefined"
  (dismiss)="closeDeleteModal($event)"
/>

<opa-vendor-edit
  [open]="showEditModal"
  [vendor]="(vendor$ | async) ?? undefined"
  (dismiss)="closeEditModal($event)"
/>
